/**
 * A UUID, shortened for reading but complete for copying.
 *
 * Requirements have no human-readable number — no `requirement_number`, no
 * sequence, and `work_order_ref` is optional and usually null on manually
 * raised demand. So four separate requirements for the same part render as four
 * identical cards distinguishable only by their creation timestamp, and there
 * is no way to say which one an order closed. The id is the only identity they
 * have, which makes showing it a correctness matter rather than a debug affordance.
 *
 * The first segment of a v4 UUID is 8 random hex digits, so a collision inside
 * one screen is not a practical concern, and the full value stays available via
 * the title attribute and by selecting the text.
 */
export function ShortId({
  id,
  prefix,
  length = 8,
}: {
  id: string;
  /** Optional leading label, e.g. "REQ". */
  prefix?: string;
  length?: number;
}) {
  return (
    <span
      title={id}
      style={{
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
        fontSize: 11,
        color: "#666",
        background: "#f1f3f5",
        border: "1px solid #e3e6ea",
        borderRadius: 4,
        padding: "1px 5px",
        whiteSpace: "nowrap",
      }}
    >
      {prefix ? `${prefix} ` : ""}
      {id.slice(0, length)}
    </span>
  );
}
